export default function IcComumity() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99935 5.06445C6.5204 5.06445 2.99805 6.14685 2.99805 8.21504C2.99805 10.2832 6.5204 11.3656 9.99935 11.3656C13.479 11.3656 17.0007 10.2832 17.0007 8.21504C17.0007 6.14685 13.479 5.06445 9.99935 5.06445ZM6.4987 12.0223V14.1227C7.36476 14.3321 8.32254 14.4602 9.29922 14.5015V12.4011C8.35578 12.3644 7.41801 12.2375 6.4987 12.0223ZM10.6995 12.4004V14.5008C11.643 14.4648 12.5808 14.338 13.5 14.122V12.0216C12.5808 12.2376 11.643 12.3644 10.6995 12.4004ZM14.9003 11.5736V13.674C16.1612 13.1454 17.0007 12.3738 17.0007 11.3656V9.26523C17.0007 10.2734 16.1612 11.045 14.9003 11.5736ZM5.09844 13.674V11.5736C3.8382 11.045 2.99805 10.2727 2.99805 9.26523V11.3656C2.99805 12.3731 3.8382 13.1454 5.09844 13.674Z"
        fill="url(#paint0_linear_23858_19538)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_23858_19538"
          x1="2.99805"
          y1="9.78298"
          x2="17.0007"
          y2="9.78298"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE259" />
          <stop offset="1" stop-color="#FFA751" />
        </linearGradient>
      </defs>
    </svg>
  );
}
